import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Separator } from '@/components/ui/separator'
import { ROOT_NODE } from './scope-tree'

const splitCountries = (value) => (value ? value.split(',').filter(Boolean) : [])

/** 页面范围的 search：node 为根、countries 为空、as_of 为空时省略对应参数 */
export const scopeSearch = ({ node, countries = [], asOf }) => {
  const params = new URLSearchParams()
  if (node && node !== ROOT_NODE) params.set('node', node)
  if (countries.length) params.set('countries', countries.join(','))
  if (asOf) params.set('as_of', asOf)
  const search = params.toString()
  return search ? `?${search}` : ''
}

/**
 * MON-93 页面状态全在 URL：?node=&countries=&as_of=。node 缺省为根 total，countries 空 = 全部国家，
 * as_of 空 = 取最新（回看历史手动改地址栏）
 */
export function usePaybackSearch() {
  const [params, setParams] = useSearchParams()
  const node = params.get('node') || ROOT_NODE
  const countries = splitCountries(params.get('countries'))
  const asOf = params.get('as_of') ?? ''
  const update = useCallback(
    (patch, options) => setParams((current) => {
      const next = {
        node: current.get('node') || ROOT_NODE,
        countries: splitCountries(current.get('countries')),
        asOf: current.get('as_of') ?? '',
        ...patch,
      }
      return new URLSearchParams(scopeSearch(next))
    }, options),
    [setParams],
  )
  return { node, countries, asOf, update }
}

/** 页头：左侧面包屑 + 标题，右侧范围筛选与 actions（排除说明 / 术语与公式按钮） */
export function PaybackHeader({ children, actions }) {
  return (
    <>
      <header className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col gap-1">{children}</div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </header>
      <Separator />
    </>
  )
}
